import axiosInstance from './AxiosInstance';
const apiUrl = "api/products"

export function getProductList(params={}) {
    const queryParams = new URLSearchParams({...params});
    return axiosInstance.get(`${apiUrl}?${queryParams.toString()}`);
}

export function exportProductApi(filter) {
    const params = new URLSearchParams({
        ...filter, export:"true"
    });
    return axiosInstance.get(`${apiUrl}?${params.toString()}`, {responseType: 'blob'});
}

export function getProduct(rackId) {
    return axiosInstance.get(`${apiUrl}/${rackId}`);
}

export function getProductStocksByRack(prodId, rack_id) {
    return axiosInstance.get(`${apiUrl}/${prodId}?rack_id=${rack_id}`);
}


export function createProduct(ProductData) {
    return axiosInstance.post(apiUrl, ProductData);
}

export function stockInProduct(stockData) {
    return axiosInstance.post('api/stocks', stockData);
}

export function stockOutProduct(stockData) {
    return axiosInstance.put('api/stocks', stockData);
}

export function updateProduct(ProductData) {
    return axiosInstance.put(apiUrl, ProductData);
}

export function deleteProduct(rackId) {
    return axiosInstance.delete(`${apiUrl}/${rackId}`);
}

export function getStockHistoryList(page, page_size, query, status, history_type, fromDate, toDate) {
    const params = new URLSearchParams({
        page, page_size, query,status, history_type, from_date:fromDate, to_date:toDate
    });
    return axiosInstance.get(`api/stock_history?${params.toString()}`);
}

export function exportStockHistoryApi(filter) {
    const params = new URLSearchParams({
        ...filter, export:"true"
    });
    return axiosInstance.get(`api/stock_history?${params.toString()}`, {responseType: 'blob'});
}


export function getProductStockList(productId, page, page_size, query) {
    const params = new URLSearchParams({
        page, page_size, query
    });
    return axiosInstance.get(`api/product_stock/${productId}?${params.toString()}`);
}

export function exportProductStockList(productId, filter) {
    const params = new URLSearchParams({...filter, export:"true"});
    return axiosInstance.get(`api/product_stock/${productId}?${params.toString()}`,{responseType: 'blob'});
}

export function updateProductStcokRack(productId, ProductData) {
    return axiosInstance.put(`api/product_stock/${productId}`, ProductData);
}

export function getBorrowedStockList() {
    return axiosInstance.get('api/borrowed_stock')
}

export function getBorrowedStockDetails(source_id) {
    return axiosInstance.get(`api/borrowed_stock/${source_id}`);
}


export function getProductStockHistoryList(id, page, page_size, query) {
    return axiosInstance.get(`api/stock_history/${id}?page=${page}&page_size=${page_size}&query=${query}`);
}

export function getBarcodeStockHistoryList(barcode, page, page_size, query) {
    return axiosInstance.get(`api/barcode_stock_history/${barcode}?page=${page}&page_size=${page_size}&query=${query}`);
}

export function getBarcodeList(page, page_size, query, status_filter) {
    return axiosInstance.get(`api/barcode?page=${page}&page_size=${page_size}&query=${query}&status=${status_filter}`);
}

export function exportBarcodeApi(filter) {
    const params = new URLSearchParams({
        ...filter, export:"true"
    });
    return axiosInstance.get(`api/barcode?${params.toString()}`, {responseType: 'blob'});
}

export function validateProductBarcode(product_barcode_no, product_id) {
    return axiosInstance.get(`api/barcode?product_barcode_no=${product_barcode_no}&product_id=${product_id}`);
}

export function getReturnStockBarcodeDetails(return_stock_barcode_no) {
    return axiosInstance.get(`api/barcode?return_stock_barcode_no=${return_stock_barcode_no}`);
}


export function createBarcode(data) {
    return axiosInstance.post('api/barcode', data);
}

export function getStockByBarcode(queryParams={barcode: "", older_stock_id: []}) {
    const params = new URLSearchParams({
        ...queryParams
    });
    return axiosInstance.get(`api/stocks?${params.toString()}`);
}

export function getPerishableStocksList(queryParams={}) {
    const params = new URLSearchParams({...queryParams});
    return axiosInstance.get(`api/perishable_stock?${params.toString()}`);
}

export function exportPerishableStocksList(queryParams={}) {
    const params = new URLSearchParams({...queryParams, export:"true"});
    return axiosInstance.get(`api/perishable_stock?${params.toString()}`,{responseType: 'blob'});
}

export function getBarcodeAction(barcode) {
    return axiosInstance.get(`api/barcode_action/${barcode}`);
}

export function dashboard() {
    return axiosInstance.get('api/dashboard');
}
export function dashboardStockOverview(view_type = "weekly") {
    return axiosInstance.get(`api/dashboard/stock_overview?view_type=${view_type}`);
}
export function dashboardProductStockOverview(id, view_type = "weekly") {
    return axiosInstance.get(`api/dashboard/stock_overview/${id}?view_type=${view_type}`);
}

export function dashboardProductUses(view_type = "weekly", stock_type = "stockin") {
    return axiosInstance.get(`api/dashboard/product_uses?view_type=${view_type}&stock_type=${stock_type}`);
}

export function dashboardProductOverUnder(stock_type = "stockunder") {
    return axiosInstance.get(`api/dashboard/product_under_over?stock_type=${stock_type}`);
}

export function searchProduct(query) {
    return axiosInstance.get(`api/search/product?query=${query}`);
}

export function updateProfile(data) {
    return axiosInstance.post(`api/auth/profile`, data);
}


export function getProductForecastList(type="monthly",  period=3, id = null) {
    if (id) {
        return axiosInstance.get(`api/product_forecast/${id}?period=${period}`);
    }
    return axiosInstance.get(`api/product_forecast?type=${type}&period=${period}`);
}

export function getTopProductForecastList() {
    return axiosInstance.get('api/top_product_forecast');
}

// Analysis

export function ABCAnalysisApi(view_type = "all") {
    return axiosInstance.get(`api/abc_analysis?view_type=${view_type}`);
}

export function VEDAnalysisApi(view_type = "all") {
    return axiosInstance.get(`api/ved_analysis?view_type=${view_type}`);
}

export function HMLAnalysisApi(view_type = "all") {
    return axiosInstance.get(`api/hml_analysis?view_type=${view_type}`);
}

export function FSNAnalysisApi(view_type = "all") {
    return axiosInstance.get(`api/fsn_analysis?view_type=${view_type}`);
}

export function StockRatioAnalysisApi(view_type = "1M") {
    return axiosInstance.get(`api/stock_age_analysis?view_type=${view_type}`);
}

export function SDEAnalysisApi() {
    return axiosInstance.get('api/sde_analysis');
}

export function importProduct(ProductData) {
    return axiosInstance.patch(apiUrl, ProductData);
}

// report 
export function getMaterialReportList(page, page_size, query) {
    return axiosInstance.get(`api/report/material?page=${page}&page_size=${page_size}&query=${query}`);
}